<template>
  <div class="user-card">
    <div class="user-card__header">
      <YorkbbsImage
        class="user-avatar"
        width="36px"
        height="36px"
        borderRadius="50%"
        animation
        :src="avatar | webpFormat(50)"
        target="_blank"
        :link="homeURL"
      ></YorkbbsImage>
      <div class="user-desc e">
        <div class="user-name">
          <a class="" target="_blank" :href="homeURL">
            {{ username }}
          </a>         
        </div>
        <div class="user-time">
          <span>{{ registerTime | timeToStr }}注册</span>
          <span v-if="latestVisitTimeVisible">，{{ latestVisitTime | timeToStr }}来过</span>
        </div>
      </div>
    </div>
    <div class="user-card__footer">
      <a target="_blank" :href="chatURL" v-if="isLogin">
        <el-button type="danger" class="user-button__msg">
          <i class="yk-car_msg"></i>
          <span>私信</span>
        </el-button>
      </a>
      <el-button class="user-button__msg" type="danger" @click="$store.commit('showLoginDialog')" v-else>
        <i class="yk-car_msg"></i>
        <span>私信</span>
      </el-button>

      <el-button class="user-button__attention" :loading="loading" @click="removeAttention" v-if="focusedByMe">
        <i class="yk-car_user"></i>
        <span>已关注</span>
      </el-button>
      <el-button class="user-button__attention" :loading="loading" @click="addAttention" v-else>
        <i class="yk-car_add"></i>
        <span>关注</span>
      </el-button>
    </div>
  </div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
  name: 'CardUser',
  /*
   :user="{
      id: post.user.id,
      avatar: post.user.avatar,
      username: post.user.username,
      registerTime: post.user.registerTime,
      latestVisitTime: post.user.latestVisitTime,
    }"
    :focusedByMe.sync="post.property.focusedByMe"
   */
  props: { user: Object, focusedByMe: [Number, Boolean] },
  data() {
    return {
      // 关注加载状态
      loading: false,
    };
  },
  computed: {
    // 用户id
    userId() {
      return this.user.id;
    },
    // 头像
    avatar() {
      return this.user.avatar;
    },
    // 用户名
    username() {
      return this.user.username;
    },
    // 注册时间
    registerTime() {
      return this.user.registerTime;
    },
    // 最后访问时间
    latestVisitTime() {
      return this.user.latestVisitTime;
    },
    latestVisitTimeVisible() {
      return new Date().getTime() - new Date(this.latestVisitTime).getTime() <= 30 * 86400000;
    },
    // 主页地址
    homeURL() {
      return hostBuild(`/home/${this.userId}`, 'home');
    },
    // 私信地址
    chatURL() {
      return hostBuild(`/chat?to=${this.userId}`, 'home');
    },
    // 是否登录
    isLogin() {
      return this.$store.getters.isLogin;
    },
    phoneAuth(){
      return this.user.phoneAuth || 0;
    }
  },
  methods: {
    /**
     * 添加关注
     */
    async addAttention() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      this.loading = true;
      await this.$axios
        .post('/user/v1/pay/attention/to', {
          toUserId: this.user.id,
        })
        .finally(() => {
          this.loading = false;
        });
      this.$success('关注成功');
      this.$emit('update:focusedByMe', 1);
    },
    /**
     * 移除关注
     */
    async removeAttention() {
      if (!this.isLogin) return this.$store.commit('showLoginDialog');

      this.loading = true;
      await this.$axios
        .post('/user/v1/remove/attention/from', {
          toUserId: this.user.id,
        })
        .finally(() => {
          this.loading = false;
        });
      this.$success('取消关注成功');
      this.$emit('update:focusedByMe', 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-card {
  padding: 20px;
  border: 1px solid #ededed;
  border-radius: 6px;
  margin-bottom: 20px;
}
.user-card__header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.user-avatar {
  margin-right: 10px;
}

.user-desc {
  flex: 1;
  width: 0;
}
.user-name {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 3px;
  a:hover {
    color: var(--primary-color);
  }
}
.user-time {
  font-size: 14px;
  color: var(--text-color-9);
  line-height: 20px;
}
.user-button__msg {
  width: 160px;
  padding: 0;
  height: 36px;
  font-size: 14px;
  i {
    font-size: inherit;
    margin-right: 5px;
  }
}
.user-button__attention {
  width: 80px;
  padding: 0;
  height: 36px;
  font-size: 14px;
  background-color: #f8f8f8;
  border: 0 none;
  color: var(--text-color-3);
  i {
    font-size: inherit;
    margin-right: 5px;
  }
  &:hover {
    color: #e43a3a;

    border-color: #f7c4c4;

    background-color: #fcebeb;
  }
}

.user-card__footer {
  display: flex;
  justify-content: space-between;
}

.auth-tag{
  margin-left: 5px;
  font-size: 12px;
  line-height: 16px;
  display: inline-block;
  font-weight: normal;
  padding: 2px 5px;
  background: #f8f8f8;
  color: #bbb;
  
  border-radius: 2px;
  &.active-auth{
    background: linear-gradient(128deg,#ff846d 1%, #ff5d2b 90%);
    color: #fff; 
  }
}
.auth-tag i{margin-right: 5px;}
</style>
